import { Identification } from '@/models';

export interface IdentificationState {
  identification: Identification | null
}

export const InitialState: IdentificationState = {
  identification: null
}
